import { Position } from '@blueprintjs/core'
import React, { FC } from 'react'
import Select from 'react-select'
import { UprightStyle } from '../../../../../types'
import { DepopSpecificValue } from '../types'
import { GutterTooltipError } from '../GutterTooltipError'
import { ProductFormGroup } from '../ProductFormGroup'

interface Props {
  specificName: string
  value: string | string[]
  options: DepopSpecificValue[]
  required?: boolean
  error?: any
  maxValues?: number
  errorTooltipOffset?: number
  errorTooltipPosition?: Position
  onChange: (v: string | string[]) => void
}

const styles: UprightStyle = {
  zeroMarginBottom: { marginBottom: 0 }
}

// Goodwill Finds' SpecificInput takes options as a string[] and uses each entry as both the value
// and the label. Depop needs them separated: it stores ids (`black`, `streetwear`) but shows names
// (`Black`, `Streetwear`), and sending the display name back would be rejected.
export const DepopSpecificSelect: FC<Props> = props => {
  const {
    specificName,
    value,
    options,
    required,
    error,
    maxValues,
    errorTooltipOffset,
    errorTooltipPosition = Position.LEFT,
    onChange
  } = props

  const mappedOptions = options.map(opt => ({
    value: opt.value,
    label: opt.displayName || opt.value,
    disabled: Array.isArray(value) && maxValues && value.length >= maxValues && !value.includes(opt.value)
  }))

  return (
    <ProductFormGroup
      title={specificName}
      error={error}
      showRequiredLabel={required}
      style={styles.zeroMarginBottom}
      className="nuke-top-margin-loadable-select"
    >
      <GutterTooltipError isOpen={!!error} offsetPx={errorTooltipOffset} position={errorTooltipPosition}>
        {Array.isArray(value) ? (
          <Select
            multi
            value={value}
            options={mappedOptions}
            onChange={(selected: { value: string }[]) => {
              if (maxValues && selected.length > maxValues) {
                return
              }
              onChange(selected.map(opt => opt.value))
            }}
            placeholder="Select"
            className="react-select-same-height-as-blueprint"
          />
        ) : (
          <Select
            value={value}
            options={mappedOptions}
            simpleValue
            onChange={v => onChange(v as string)}
            placeholder="Select"
            className="react-select-same-height-as-blueprint"
          />
        )}
      </GutterTooltipError>
    </ProductFormGroup>
  )
}
